export const BASELINECSS_MATERIALUI = "materialui"
export const BASELINECSS_CUSTOM = "custom"
export const JSS_SERVERSIDE = "plp-jss-server-side-"

export enum Horizontal {
    ltr = "left",
    rtl = "right",
}

export type FilterType = "filter" | "price" | "feat" | "link"

export const FILTER_SETTINGS_COOKIE = "filterSettings"

export enum SearchApiRequestTypes {
    Category = "Category",
    Keyword = "Keyword",
}

export const SEARCH_CATEGORY_SEGMENT = "shop"
export const SEARCH_CATEGORY_SEGMENTS_MERCHANDISE = ["shop", "promotions", "brands"]

export enum ViewLinkOptions {
    none,
    viewMore,
    viewAll,
}

export const FILTERS_SHOW_VIEW_ALL_COUNT = 20
export const FILTERS_SHOW_VIEW_MORE_COUNT = 8
export const FILTERS_SHOW_VIEW_MORE_COUNT_EXTENDED = 30
export const FILTERS_SHOW_VIEW_MORE_COUNT_EXTENDED_HORIZONTAL = 50

export const HORIZONTAL_FILTERS_ITEM_COUNT_DEFAULT = 5
export const HORIZONTAL_FILTERS_ITEM_COUNT_LARGE = 6
export const ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_ITEM_COUNT = 3
export const HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH = 25
export const ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH = 16.6666
export const ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_EIGHT_ITEM_COUNT_WIDTH = 12.5
export const ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_SEVEN_ITEM_COUNT_WIDTH = 14.29

export const REALM_HEADER = "x-next-realm"
export const TERRITORY_HEADER = "x-next-territory"
export const LANGUAGE_HEADER = "x-next-language"
export const DEV_ESI_HEADER = "test-with-local-esi"
export const VIEWPORT_SIZE_HEADER = "x-next-viewport-size"
export const REDIRECTION_HEADER = "x-next-enable-redirection"
export const SEARCH_BANNER_HEADER = "x-next-banner-format"
export const SEARCH_BANNER_HEADER_DEFAULT = "html"
export const SEARCH_BANNER_HEADER_TEMPLATED = "webcontent"
export const SESSION_STORAGE_ACTIVE_DEPT_NAME = "PrimaryNavDeptSelector"
export const GTM_SEARCH_RESULTS = "searchResults"
export const SEARCH_BANNER_ENTRYPOINT = "plp-search-banner-entrypoint"

export const FILTER_GRID_SCROLL_HEIGHT = 690
export const FILTER_GRID_TOP_SPACER_HEIGHT = 25

export const DIGIT_REGEX = RegExp(/^\d/)

export const HISTORY_EVENT = "PLP-FILTER-EVENT"

export const STICKY_HEADER_SCROLL_TRIGGER = 44

export const TOKEN_CANCELLATION_FLAG = "TOKEN_CANCELLATION"

export const TERRITORY_GB = "gb"
export const TERRITORY_COTTON22 = "cotton22"

export const REGION_UK = "uk"

export const REGION_INTERNATIONAL = "international"

export const LANGUAGE_ENGLISH = "en"

export const DEFAULT_FILTER_SPINNER_TIMEOUT = 5000

export const BRAND = "brand"
export const BRAND_0_9 = "0-9"

export const GENDER = "gender"
export const CATEGORY = "category"
export const LINK = "link"

export const SALE_URL_CATEGORY_SEGMENT = "issale-true"
export const SALE_FILTER_KEY = "feat:sale"

export enum ESISeparator {
    ProductFragment = "<=ProductFragment=>",
    SearchBanner = "<=SearchBanner=>",
    ProductArray = "<=ProductArray=>",
}
export const FOOTER_ID = "next-footer-entrypoint"
export const PLP_ID = "next-plp-entrypoint"

export const FACETS_CONTAINER_OFFSET = 25
export const FACETS_CONTAINER_MINIMUM_PADDING = 49

export const SEARCH_BANNER_INCLUDE_COMPONENTS = "search-banner"
export const SEO_METADATA_INCLUDE_COMPONENTS = "seo-metadata"
export const TEMPLATE_OVERRIDE_INCLUDE_COMPONENTS = "template-override"

export const CACHE_HEADERS_CACHE_CONTROL = "cache-control"
export const CACHE_HEADERS_EDGE_CACHE_TAG = "edge-cache-tag"
export const CACHE_HEADERS_LAST_MODIFIED = "last-modified"
export const SEARCH_BANNER_CACHE_TAG = "searchbannerui"
export const SEARCH_CACHE_TAG = "plpui"
export const PLP_CACHE_TAG = "plp"
export const VERSION = "version"
export const V1 = "v1"
export const V2 = "v2"

export const BR_UID_2 = "_br_uid_2"
export const BR_MT_SEARCH = "_br_mt_search"
export const BR_UID_DEFAULT_VALUE = "uid%3D9624001141133%3Av%3D13.0%3Ats%3D1578565383488%3Ahc%3D138"
export const BR_SEGMENT_ID = "_br_seg_id"
export const BR_UNCLASSIFIED_SEGMENT = "unclassified"
export const CATEGORY_FILTERS_REGEX = /(([a-z, 0-9]*).-[a-z, 0-9,%]*)+/g

export const GTM_PRODUCT_IMPRESSIONS_EVENT = "ee-productImpression"
export const SWIPER_ITEMS_PER_PAGE = 4
export const GPT_ENDPOINT = "/21848067774/display/display_plp_reactive"
export const GPT_ADVERT_ORIGIN = "https://s0.2mdn.net"

export const featAvailable = "feat:available"
export const featDeliverBy = "feat:deliveryby"
export const featBackInStock = "feat:backinstock"
export const featNewIn = "feat:newin"

export const filterLatestArrivalKey = "latestarrivals"

export const MAX_PRODUCTS_BY_SEARCH_API = 9900
export const PRODUCTS_PER_PAGE = 12
export const MAX_PAGE_TO_LOAD = Math.floor(MAX_PRODUCTS_BY_SEARCH_API / PRODUCTS_PER_PAGE)

export const SCRIPT_TAG_START = `<script id="itemscache">itemsCacheJson=`
export const SCRIPT_TAG_END = `//itemscache-script</script>`

export const PAGE_LOAD_TRIGGER = {
    nextPage: "NEXT",
    previousPage: "PREVIOUS",
    filter: "FILTER",
}

// "color-contrast" is listed as a exception only temporarily, as UX is changing things around, and the green button, that's breaking accessibility, is going to be changed
// when that happens, "color-contrast" needs to be removed from this object

// Added "duplicate-id" in the list of exceptions as the issue it's reporting seems to be intermittent, and actually invalid.
// It's complaining about duplicate ID's for placeholder Product Summary elements, whose ID's contain their unique ID (so it's not duplicate, but for some reason the Axe asserter reads it as a dupe)
export const AXE_CONFIGURATION = Object.freeze({
    rules: [
        {
            id: "color-contrast",
            enabled: false,
        },
        {
            id: "duplicate-id",
            enabled: false,
        },
        // Modal problems, can be fixed with container={getPortalEntrypoint()}, but the scroll bar doesn't disappear
        // which causes styling issues especially on mobile
        {
            id: "landmark-one-main",
            enabled: false,
        },
        {
            id: "region",
            enabled: false,
        },
        {
            id: "page-has-heading-one",
            enabled: false,
        },
    ],
})

export const kidsGenders: string[] = [
    "gender-youngergirls",
    "gender-oldergirls",
    "gender-newborngirls",
    "gender-babygirls",
    "gender-girls",
    "gender-youngerboys",
    "gender-olderboys",
    "gender-newbornboys",
    "gender-babyboys",
    "gender-boys",
    "gender-newbornunisex",
    "gender-babyunisex",
    "gender-unisex",
]

export const kidsGenderCategories: string[] = [
    "youngergirls",
    "oldergirls",
    "newborngirls",
    "babygirls",
    "girls",
    "youngerboys",
    "olderboys",
    "newbornboys",
    "babyboys",
    "boys",
    "newbornunisex",
    "babyunisex",
    "unisex",
]

export const genderGroups = {
    girls: ["youngergirls", "oldergirls", "newborngirls", "babygirls", "girls"],
    boys: ["youngerboys", "olderboys", "newbornboys", "babyboys", "boys"],
    women: ["women"],
    men: ["men"],
    unisex: ["newbornunisex", "babyunisex", "unisex"],
}

export const excludedParams = ["dp", "cachebuster"]

export const LOADABLE_NAMESPACE = "PLP"
export const NEW_URL_FACET_SEPARATOR = "~"

export const PRODUCT_TYPE = "product"
export const SUIT_TYPE = "suit"
export const PRICE_SLIDER_DELAY = 300
export const BUNDLE_PRICE_LABEL_TEXT = "bundlePriceLabel"

export const QUERY_PARAMETER_NEW_IN = "show-new-in"
export const QUERY_PARAMETER_IMAGE_RATIO = "image-ratio"
export const QUERY_PARAMETER_TEMPLATE_OVERRIDE = "template-override"

export const validTemplates = {
    standard: {},
    cotton22: {},
    linen23: {},
    silk24: {},
    backstitch22: {},
    bastingstitch23: {},
    blanketstitch24: {},
    blindstitch25: {},
}

export const validImageRatios = {
    "1x1": {},
    "2x3": {},
    "3x4": {},
}

export const ITEMS_STRING_QUERY_STRING = "itemsString"
export const FRAGMENT_ITEMS_QUERY_STRING = "fragmentItems"

export const FOLLOW_NIKE_BANNER_ID_DEV = "65043146ee3731e1a316e8a8"
export const FOLLOW_NIKE_BANNER_ID_PROD = "655205b76292134e865a0650"

export const SHOP = "shop"
export const CRITERIA = "criteria"
export const AND = "and"
export const SORT = "sort"
export const SORT_BY = "Sort By"
export const SCORE = "score"
export const MOST_RELEVANT = "Most Relevant"
export const SELECT_RANGE = "Select a range"
export const SELECT_PRICE_RANGE = "Select a price range"

export const IMAGE_EXTENSION = ".jpg"
export const SOFA_COLOUR_CHIP_PREFIX = "SofaSwatchView"
export const COLOUR_CHIP_PREFIX = "AltItemSwatch/21x21"

export const SHOW_INITIAL_COLOURCHIPS = 18
export const COLOURCHIP_GREY_PLACEHOLDER_URL =
    "/Common/Items/Default/Default/ItemImages/AltItemSwatch/21x21/greySquarePlaceholder.jpg"
export const PRODUCT_IMAGE_GREY_PLACEHOLDER_URL =
    "/Common/Items/Default/Default/ItemImages/Search/224x336/greyPlaceholder.jpg?X56"
export const FIT_ICON_PLACEHOLDER_URL = "/images/shared/transparent-image.png"
export const LAZY_SIZES_CLASSNAME = "lazyload"
export const SWIPER_LAZYLOAD_CLASSNAME = "swiper-lazy"
export const COLOURCHIP_UNEXPANDED_HEIGHT = 48
export const FAV_TIMER_LENGTH = 1000
export const MAX_LIMIT_FAVOURITES_FALLBACK = 150
export const LANG_EN = "en"
export const DEPARTMENT_MENSWEAR = "menswear"
export const DEPARTMENT_HOMEWARE = "homeware"
export const GTM_PRODUCT_CLICK_EVENT = "ee-productClick"
export const FAV_ADD = "FAV_ADD"
export const FAV_REMOVE = "FAV_REMOVE"
export const FAV_ERROR_LIMIT_EXCEEDED = "MaximumLimitExceeded"
export const FAV_CATEGORY_EXCLUSION = ["Flowers", "Plants"]
export const WHEN_TO_LOAD_ADDITIONAL_COLOURCHIPS = 5
export const CLEARANCE_SASH_IMAGE_NAME = "CLEARANCE"
export const SALE_SASH_IMAGE_NAME = "SALE_CORNER_LEFT"
export const SASH_IMAGE_EXTENSION = ".png"
export const NO_INDEX_NO_FOLLOW_META_ROBOTS = "noindex, nofollow"

export const SITE_URL_HEADER = "x-next-siteurl"

export enum LowercaseFits {
    tall = "tall",
    petite = "petite",
    regular = "regular",
}

export enum Fits {
    Tall = "Tall",
    Petite = "Petite",
    Regular = "Regular",
}

export const FitsIcons = Object.freeze({
    Tall: "next_fit-tall.svg",
    Petite: "next_fit-petite.svg",
})

export enum SaleSashPosition {
    TL = "TL",
    TR = "TR",
    BL = "BL",
    BR = "BR",
}

export const BundleType = "bundle" as const
export const SuitType = "suit" as const
export const SofaType = "sofa" as const
export const ProductType = "product" as const
export const BASELINE_PRODUCT_ID = "000000" as const

export type SummaryType = typeof SuitType | typeof ProductType | typeof SofaType | typeof BundleType

export const PRODUCT_SUMMARY_ID = "plp-product-summary-entrypoint"
export const PRODUCT_SUMMARY_TILE_ID = "plp-product-summary-tile"
export const PRODUCT_SUMMARY_CACHE_TAG = "productsummaryui"
export const CACHE_HEADER_LAST_MODIFIED = "last-modified"
export const LTR = "ltr"
export const PLP_DEFAULT_TITLE_CONTAINER = "plp-results-title-container"

export const GTM_FAVOURITES = "favourites"
export const GTM_ADD_FAVOURITES = "addFavourites"
export const GTM_REMOVE_FAVOURITES = "removeFromFavourites"
export const GTM_ERROR_ADD_FAVOURITES = "errorAddFromFavourites"
export const GTM_ERROR_REMOVE_FAVOURITES = "errorRemoveFromFavourites"

export const MADE_TO_MEASURE = "madeToMeasure"
export const PERSONALISED = "personalised"
export const M2M = "M2M"
export const HOMEWARE = "homeware"

export const BASELINECSS_GENERATE_CSS_ITEM_NUMBER = "GENERATE_CSS_ONLY"

export const DEFAULT_TEST_PRODUCT_ITEM_NUMBER = "530205"
export const DEFAULT_TEST_SOFA_ITEM_NUMBER = "D55556"

export const DEFAULT_COLOURCHIPS_SLICE = 3
export const XSMALL_SCREEN_COLOURCHIPS_SLICE = 3
export const SMALL_SCREEN_COLOURCHIPS_SLICE = 4
export const MEDIUM_SCREEN_COLOURCHIPS_SLICE = 6
export const MEDIUM_SCREEN_FIVE_COLOURCHIPS_SLICE = 5
export const LARGE_SCREEN_COLOURCHIPS_SLICE = 7
export const XL_SCREEN_COLOURCHIPS_SLICE = 8
export const PLP_ENTRYPOINT = "next-plp-entrypoint"

export const FEAT = "feat"

export const THUMBNAIL_IMAGE_FALLBACK_PATH = "/searchcategorythumbnails/homehomewaresofas-filters/missing.png"

export const AGGREGATORQUERYTYPES = (version = "v1") => ({
    product: `GetProductSummaryByItemNumber_${version.toUpperCase()}`,
    suit: `GetSuitSummaryByCompositeItemNumber_${version.toUpperCase()}`,
    sofa: `GetSofaByItemNumber_${version.toUpperCase()}`,
})

export const MASID_COOKIE_NAME = "MASId"
export const X_NEXT_SEARCH_SOURCE = "x-next-search-source"
export const CMS_PAGE_ID = "cmsPageId"
export const PARTIAL_VIEW_PLP = "partialViewPLP"
export const ECONNABORTED = "ECONNABORTED"
export const PREVIOUS = "previous"
export const NEXT = "next"
export const LIVE = "live"
export const SEARCH = "Search"
